<div class="container-fluid py-4">
    <div class="row mb-3">
        <div class="col-md-4">
            <h2>Departments</h2>
            <button *ngIf="selectedDepartments.length > 0" class="btn btn-info" readOnlyIfNoGroupPermissionDirective [showToastWhenRendering]="false"
                (click)="openCopyTimeSlotsModal(copyTimeSlotsModal)">
                <i class="bi bi-arrow-down-up"></i> Copy Time Slots
            </button>
        </div>

        <div class="col d-flex justify-content-end align-items-center gap-2">
            <button routerLink="/departments/create" class="btn btn-primary text-nowrap"  readOnlyIfNoGroupPermissionDirective [showToastWhenRendering]="false">
                <i class="bi bi-plus-lg me-2"></i> Add New Department
            </button>

            <!-- Button to Generate JSON File -->
            <div class="dropdown" *ngIf="isAllowedTenant">
                <a class="btn btn-secondary dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown"
                    aria-expanded="false">
                    <i class="bi bi-file-earmark-arrow-down"></i> Generate JSON
                </a>

                <ul class="dropdown-menu">
                    <li><a class="dropdown-item" role="button" (click)="generateDepartmentsJson()">Departments Only</a>
                    </li>
                    <li><a class="dropdown-item" role="button" (click)="generateScheduleJson()">Departments with
                            Schedules</a>
                    </li>
                </ul>
            </div>

            <!-- Toggle Completion Status Button -->
            <button (click)="toggleDepartmentEntryComplete()" class="btn text-nowrap" [ngClass]="{
                'btn-success': isDepartmentEntryComplete,
                'btn-outline-danger': !isDepartmentEntryComplete}">
                <i class="bi" [ngClass]="{
                'bi-check-circle-fill': isDepartmentEntryComplete,
                'bi-x-circle': !isDepartmentEntryComplete}"></i>
                {{ isDepartmentEntryComplete ? 'Completed' : 'Incomplete' }}
            </button>

            <!-- Import Departments Button -->
            <button *ngIf="isAllowedTenant" class="btn btn-warning text-nowrap" (click)="fileInput.click()">
                <i class="bi bi-upload"></i> Import Departments
                <input type="file" #fileInput (change)="importDepartments($event)" accept=".json" class="d-none">
            </button>

        </div>
    </div>

    <div class="row">
        <div class="col-12">
            <div class="card shadow-sm">
                <div class="card-header bg-primary text-white">
                    <h5 class="mb-0">Department List</h5>
                </div>
                <div class="card-body p-0">
                    <!-- ag-Grid Table -->
                    <ag-grid-angular style="width: 100%; height: 600px;" class="ag-theme-alpine" [rowData]="departments"
                        [columnDefs]="columnDefs" rowSelection="multiple"
                        (selectionChanged)="onSelectionChanged($event)">
                    </ag-grid-angular>



                </div>
            </div>
        </div>
    </div>
</div>


<ng-template #copyTimeSlotsModal let-modal>
    <div class="modal-header">
        <h5 class="modal-title" id="copyTimeSlotsModalLabel">Select Source Department</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
            (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">

        <form>
            <div class="mb-3">
                <label for="sourceDepartment" class="form-label">Source Department</label>
                <select class="form-select" id="sourceDepartment" [(ngModel)]="sourceDepartmentId"
                    name="sourceDepartmentId">
                    <option [ngValue]="null">-- Select Source Department --</option>
                    <option *ngFor="let department of departments" [value]="department.id">
                        {{ department.name }}
                    </option>
                </select>
            </div>
        </form>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
            (click)="modal.dismiss('cancel click')">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="confirmCopyTimeSlots(modal)"
            [disabled]="!sourceDepartmentId">
            Copy Time Slots
        </button>
    </div>
</ng-template>